import React from 'react';
import PropTypes from 'prop-types';

const CreateActivityMaintenanceButton = ({ onClick }) => (
  <button
    className="btn btn-label btn-primary w-100"
    id="add-btn"
    onClick={onClick}
  >
    <i className={`${Icons.plus} label-icon`}></i> Agendar Actividad de Mantención
  </button>
);

CreateActivityMaintenanceButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CreateActivityMaintenanceButton;
